import { render, staticRenderFns } from "./Turno.vue?vue&type=template&id=4dc38564&scoped=true&lang=pug&"
import script from "./Turno.vue?vue&type=script&lang=js&"
export * from "./Turno.vue?vue&type=script&lang=js&"
import style0 from "./Turno.vue?vue&type=style&index=0&id=4dc38564&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dc38564",
  null
  
)

export default component.exports